import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '../lib/api';
import { mapaPunto } from '../lib/mapas';
import '../styles/Regalos.css';
import '../styles/Extras.css';
import { LOGO, LOGO_SRCSET } from '../lib/imagenes';

const hora = (s) => s ? new Date(String(s).replace(' ', 'T') + 'Z').toLocaleString('es-AR', { dateStyle: 'short', timeStyle: 'short' }) : '';

// Página pública para la persona de confianza (no necesita cuenta). Se actualiza sola cada 30 s.
export default function CitaSeguraPublicaPage() {
  const { token } = useParams();
  const [cita, setCita] = useState(undefined);
  const [err, setErr] = useState('');

  useEffect(() => {
    let vivo = true;
    const cargar = () => api.citaSeguraPublica(token)
      .then(d => { if (vivo) { setCita(d); setErr(''); } })
      .catch(e => { if (vivo) { setCita(null); setErr(e.message || 'Este enlace venció o no existe.'); } });
    cargar();
    const t = setInterval(cargar, 30000);
    return () => { vivo = false; clearInterval(t); };
  }, [token]);

  return (
    <div className="regalos-page">
      <div className="regalos-container container cita-publica">
        <img src={LOGO} srcSet={LOGO_SRCSET} sizes="72px" alt="Cupido con Mate" style={{ width: 72, display: 'block', margin: '0 auto 12px' }} />
        <h1 className="regalos-title" style={{ textAlign: 'center', marginBottom: 20 }}>🛡️ Cita segura</h1>

        {cita === undefined ? <p className="regalos-empty">Cargando…</p>
          : !cita ? <p className="regalos-empty">{err}</p>
          : (
            <div className={`descuento-card cita-publica-card cita-publica--${cita.estado}`}>
              {cita.estado === 'ayuda' && (
                <div className="cita-publica-alerta">
                  🆘 <strong>{cita.nombre} pidió ayuda</strong>{cita.ayuda?.at ? ` (${hora(cita.ayuda.at)})` : ''}.
                  {cita.ayuda?.lat != null && <> <a href={mapaPunto(cita.ayuda.lat, cita.ayuda.lng)} target="_blank" rel="noopener noreferrer">Ver su ubicación en el mapa</a>.</>}
                  {' '}Si no responde, llamá al <a href="tel:911">911</a>.
                </div>
              )}
              {cita.estado === 'terminada' && <div className="cita-publica-ok">💚 {cita.nombre} avisó que terminó la cita y está bien{cita.terminada_at ? ` (${hora(cita.terminada_at)})` : ''}.</div>}
              <p>Hola{cita.contacto_nombre ? ` ${cita.contacto_nombre}` : ''}: <strong>{cita.nombre}</strong> te eligió como persona de confianza para su cita.</p>
              <p>📍 <strong>Dónde:</strong> {cita.lugar}</p>
              <p>🕐 <strong>Cuándo:</strong> {cita.fecha_hora}</p>
              {cita.con_nombre && <p>👤 <strong>Con:</strong> {cita.con_nombre}</p>}
              <p className="descuento-cond">Esta página se actualiza sola. Si {cita.nombre} toca "Necesito ayuda", vas a ver acá su ubicación.</p>
            </div>
          )}
      </div>
    </div>
  );
}
